import { api } from '../api';
import { etagAtual } from '../data/mundoSync';

export interface ManequimNoMapa {
  readonly id: string;
  readonly x: number;
  readonly y: number;
  readonly variante: 'nordeste' | 'noroeste';
  readonly dificuldadeArma: number;
  readonly dificuldadeMagia: number;
  readonly alcance: number;
  readonly rotulo: string;
  readonly uso: 'treino' | 'combate';
}

const ID_OK = /^[a-z0-9-]+$/;
const ROTULO_OK = /^manequim\.rotulo\.[a-z0-9-]+$/;
const VAZIO: readonly ManequimNoMapa[] = [];

/** Espelha `ManequimLimits.DificuldadePadrao` no servidor. */
export const MANEQUIM_DIFICULDADE_PADRAO = 30;
/** Espelha `ManequimLimits.FaixaDaJanela`. */
export const MANEQUIM_FAIXA = 10;
/** Espelha `ManequimLimits.AlcancePadrao`. */
export const MANEQUIM_ALCANCE_PADRAO = 1;

export function janelaDeTreino(skill: number, dificuldade: number): number {
  const v = (dificuldade + MANEQUIM_FAIXA - skill) / MANEQUIM_FAIXA;
  if (v <= 0) return 0;
  if (v >= 1) return 1;
  return v;
}

export async function carregarManequins(mapaArquivo: string, sinal?: AbortSignal): Promise<readonly ManequimNoMapa[]> {
  const stem = mapaArquivo.replace(/\.json$/i, '');
  if (!ID_OK.test(stem)) return VAZIO;
  const etag = etagAtual() || '1-00000000';
  try {
    const lista = await api.manequinsDoMundo(etag, stem);
    if (sinal?.aborted) return VAZIO;
    const out: ManequimNoMapa[] = [];
    for (const m of lista) {
      if (!m.id || !ID_OK.test(m.id)) continue;
      const variante = m.variante === 'noroeste' ? 'noroeste' : 'nordeste';
      const alcance = m.alcance | 0;
      if (alcance < 1 || alcance > 3) continue;
      const rotulo = typeof m.rotulo === 'string' && ROTULO_OK.test(m.rotulo) ? m.rotulo : '';
      if (!rotulo) continue;
      out.push({
        id: m.id,
        x: m.x | 0,
        y: m.y | 0,
        variante,
        dificuldadeArma: m.dificuldadeArma,
        dificuldadeMagia: m.dificuldadeMagia,
        alcance,
        rotulo,
        uso: m.uso === 'combate' ? 'combate' : 'treino'
      });
      if (out.length >= 16) break;
    }
    return out;
  } catch {
    return VAZIO;
  }
}
